"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icons = require("@ant-design/icons");

var _AppConfig = require("../configs/AppConfig");

var dashBoardNavTree = [{
  key: 'home',
  path: "".concat(_AppConfig.APP_PREFIX_PATH, "/home"),
  title: 'sidenav.home',
  icon: _icons.DashboardOutlined,
  breadcrumb: false,
  submenu: []
}];
var parentManage = [{
  key: 'parent',
  path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent"),
  title: 'sidenav.parent',
  icon: '',
  breadcrumb: false,
  submenu: [{
    key: 'parent',
    path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent"),
    title: 'sidenav.parent',
    icon: _icons.UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [{
      key: 'parent-all',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/allparent"),
      title: 'sidenav.parent.all',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'parent-new',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests"),
      title: 'sidenav.parent.new',
      icon: '',
      breadcrumb: false,
      submenu: [{
        key: 'parent-new',
        path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests/enroll"),
        title: 'sidenav.parent.requests.enroll',
        icon: '',
        breadcrumb: false,
        submenu: []
      }, {
        key: 'parent-new',
        path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests/drop"),
        title: 'sidenav.parent.requests.drop',
        icon: '',
        breadcrumb: false,
        submenu: []
      }, {
        key: 'parent-new',
        path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests/history"),
        title: 'sidenav.parent.requests.history',
        icon: '',
        breadcrumb: false,
        submenu: [{
          key: 'parent-new',
          path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests/history/enroll"),
          title: 'sidenav.parent.requests.history',
          icon: '',
          breadcrumb: false,
          submenu: []
        }, {
          key: 'parent-new',
          path: "".concat(_AppConfig.APP_PREFIX_PATH, "/parent/requests/history/drop"),
          title: 'sidenav.parent.requests.history',
          icon: '',
          breadcrumb: false,
          submenu: []
        }]
      }]
    }]
  }]
}];
var rmManage = [{
  key: 'rm',
  path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm"),
  title: 'sidenav.rm',
  icon: '',
  breadcrumb: false,
  submenu: [{
    key: 'rm',
    path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm"),
    title: 'sidenav.rm',
    icon: _icons.UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [{
      key: 'rm-all',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm/all"),
      title: 'sidenav.rm.all',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, // {
    //   key: 'rm-add',
    //   path: `${APP_PREFIX_PATH}/rm/add`,
    //   title: 'sidenav.rm.addRM',
    //   icon: '',
    //   breadcrumb: false,
    //   submenu: []
    // },
    {
      key: 'rm-audit',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm/audit"),
      title: 'sidenav.rm.audit',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'rm-rating',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm/rating"),
      title: 'sidenav.rm.rating',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'rm-report',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm/report"),
      title: 'sidenav.rm.report',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'rm-RMAttendance',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/rm/RMAttendance"),
      title: 'sidenav.rm.rmAttendance',
      icon: '',
      breadcrumb: false,
      submenu: []
    }]
  }]
}];
var operations = [{
  key: 'operations',
  path: "".concat(_AppConfig.APP_PREFIX_PATH, "/operations"),
  title: 'sidenav.operations',
  icon: '',
  breadcrumb: false,
  submenu: [{
    key: 'operations',
    path: "".concat(_AppConfig.APP_PREFIX_PATH, "/operations"),
    title: 'sidenav.operations',
    icon: _icons.UsergroupAddOutlined,
    breadcrumb: false,
    submenu: [{
      key: 'math',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/operations/mathResponse"),
      title: 'sidenav.operations.mathResponse',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'english',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/operations/englishResponse"),
      title: 'sidenav.operations.englishResponse',
      icon: '',
      breadcrumb: false,
      submenu: []
    }]
  }]
}];
var upload = [{
  key: 'upload',
  path: "".concat(_AppConfig.APP_PREFIX_PATH, "/upload"),
  title: 'sidenav.upload',
  icon: '',
  breadcrumb: false,
  submenu: [{
    key: 'upload',
    path: "".concat(_AppConfig.APP_PREFIX_PATH, "/upload"),
    title: 'sidenav.upload',
    icon: _icons.UploadOutlined,
    breadcrumb: false,
    submenu: [{
      key: 'student details',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/upload/student"),
      title: 'sidenav.upload.studentDeatils',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'rm details',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/upload/rm"),
      title: 'sidenav.upload.rmDeatils',
      icon: '',
      breadcrumb: false,
      submenu: []
    }, {
      key: 'morning details',
      path: "".concat(_AppConfig.APP_PREFIX_PATH, "/upload/morning"),
      title: 'sidenav.upload.morningResponse',
      icon: '',
      breadcrumb: false,
      submenu: []
    }]
  }]
}]; // const helpAndSupport = [{
//   key: 'helpAndSupport',
//   path: `${APP_PREFIX_PATH}/helpAndSupport`,
//   title: 'sidenav.hAS',
//   icon: '',
//   breadcrumb: false,
//   submenu: [
//      {
//       key: 'helpAndSupport',
//       path: `${APP_PREFIX_PATH}/helpAndSupport`,
//       title: 'sidenav.hAS',
//       icon: UploadOutlined ,
//       breadcrumb: false,
//       submenu:[
//         {
//           key: 'helpAndSupport-raiseProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/raiseProblem`,
//           title: 'sidenav.hAS.raiseProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'helpAndSupport-pastProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/pastProblem`,
//           title: 'sidenav.hAS.pastProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'helpAndSupport-rmProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/rmProblem`,
//           title: 'sidenav.hAS.rmProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//           },
//       ]
//     } ,
//   ]
// }
// ]
// const inventoryManage = [{
//   key: 'inventory',
//   path: `${APP_PREFIX_PATH}/inventory`,
//   title: 'sidenav.inventory',
//   icon: '',
//   breadcrumb: false,
//   submenu: [
//      {
//       key: 'inventory',
//       path: `${APP_PREFIX_PATH}/inventory`,
//       title: 'sidenav.inventory',
//       icon: UsergroupAddOutlined ,
//       breadcrumb: false,
//       submenu:[
//         {
//           key: 'inventory-received',
//           path: `${APP_PREFIX_PATH}/inventory/received`,
//           title: 'sidenav.inventory.received',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'inventory-send',
//           path: `${APP_PREFIX_PATH}/inventory/send`,
//           title: 'sidenav.inventory.send',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//           },
//           {
//             key: 'inventory-return',
//             path: `${APP_PREFIX_PATH}/inventory/return`,
//             title: 'sidenav.inventory.return',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-CLstock',
//             path: `${APP_PREFIX_PATH}/inventory/CLstock`,
//             title: 'sidenav.inventory.CLstock',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-RMstock',
//             path: `${APP_PREFIX_PATH}/inventory/RMstock`,
//             title: 'sidenav.inventory.RMstock',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-audit',
//             path: `${APP_PREFIX_PATH}/inventory/audit`,
//             title: 'sidenav.inventory.audit',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-exchange',
//             path: `${APP_PREFIX_PATH}/inventory/exchange`,
//             title: 'sidenav.inventory.exchange',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           }
//       ]
//     } ,
//   ]
// }
// ]

var NavigationConfig = [].concat(dashBoardNavTree, parentManage, rmManage, operations, upload);
var _default = NavigationConfig;
exports.default = _default;